<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="box_1 flex-col">
        <div class="group_2 flex-row">
          <span class="paragraph_1">
            开始
            <br />
            考试
          </span>
          <span class="paragraph_2">
            开始
            <br />
            考试
          </span>
          <img
            class="image_1"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngb0234b92e382ab9878c54affd6f0e1728d494dab2a6c1df1b59d89617b8aeb2c.png"
          />
        </div>
      </div>
      <div class="box_2 flex-col">
        <div class="box_3 flex-col">
          <div class="text-wrapper_1 flex-col"><span class="text_1">一、ArrayList和LinkedList的区别？</span></div>
          <div class="box_4 flex-col">
            <div class="text-wrapper_2 flex-row justify-between">
              <span class="text_2">A</span>
              <span class="text_3">答案答案</span>
            </div>
            <div class="text-wrapper_3 flex-row justify-between">
              <span class="text_4">B</span>
              <span class="text_5">答案答案</span>
            </div>
          </div>
          <div class="text-wrapper_4 flex-row justify-between">
            <span class="text_6">C</span>
            <span class="text_7">答案答案</span>
          </div>
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngda3eea486e87cc06a877d6b47553360051dc20897203d0315d3568f1b70d5db6.png"
          />
          <div class="box_5 flex-row justify-between">
            <div class="text-wrapper_5 flex-col"><span class="text_8">上一题</span></div>
            <div class="text-wrapper_6 flex-col"><span class="text_9">下一题</span></div>
          </div>
          <div class="text-wrapper_7 flex-row justify-between">
            <span class="text_10">D</span>
            <span class="text_11">答案答案</span>
          </div>
        </div>
      </div>
      <div class="box_6 flex-col">
        <div class="text-wrapper_8 flex-col"><span class="text_12">交卷</span></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="scss" src="./assets/index.scss" />